import {
    API_ROOT,
    API_NEWS
} from 'apiConfig'

var api = {
    newsCategory: API_NEWS.concat('/category'),
    newsList: API_NEWS.concat('/lists'),
    strategyList: API_NEWS.concat('/recommendEa'),
    newsBanner: API_NEWS.concat('/newsBanner'),
    // salonBanner: '/json/salonBanners.json',
    salonBanner: API_ROOT.concat('/salon/period'),
    questionList: API_ROOT.concat('/salon/allQuestion'),
    recentList: '/json/salon/recentList.json',
    allList: '/json/salon/allList.json',
    analystList: API_ROOT.concat('/salon/analystList'),
    // analystList: '/json/salon/analystList.json',
    articleList: '/json/salon/articleList.json',
    salonList: '/json/salon/salonList.json',
    salonAsk: API_ROOT.concat('/salon/ask'),
    allDynamicList: API_ROOT.concat('/salon/getDynamic'),
    wholeArticleList: API_NEWS.concat('/search'),
    searchAds: API_NEWS.concat('/getSearchAds'),

}

/**
 * 汇市阅读接口
 */
//侧栏分类接口
export const NewsCategory = api.newsCategory
//新闻列表接口
export const NewsList = api.newsList
//推荐EA策略接口
export const StrategyList = api.strategyList
//banner轮播接口
export const NewsBanner = api.newsBanner

/**
 * 沙龙中心接口
 */
 //首页banner图接口
 export const SalonBanner = api.salonBanner
 //最近问答列表
 export const RecentList = api.recentList
 //全部问答列表
 export const AllList = api.allList
 // 问题列表
 export const QuestionList = api.questionList
 //分析师列表
 export const AnalystList = api.analystList
 //沙龙文章列表
 export const ArticleList = api.articleList
 //分析师主页沙龙列表
 export const SalonList = api.salonList
 // 分析师主页全部动态列表
 export const AllDynamicList = api.allDynamicList
 // 分析师沙龙提问
 export const SalonAsk = api.salonAsk

 export const WholeArticleList = api.wholeArticleList

 export const SearchAds = api.searchAds



// WEBPACK FOOTER //
// ./src/service/common/api/address.js